import { useAhaFlag } from '@/hooks/useAhaFlag';
import { PersonalizationSettingsSection } from './PersonalizationSettingsSection';

// SettingsPanel — composite settings panel mounted inside Account.tsx > Profile.
// Today it only carries the P5 PersonalizationSettingsSection (privacy fix #3),
// but is a stable extension surface for future settings (notifications, etc).
export default function SettingsPanel() {
  const consentFlag = useAhaFlag('FYD_AHA_PERSONALIZATION_CONSENT');
  return (
    <div className="space-y-6" data-testid="settings-panel">
      {consentFlag && <PersonalizationSettingsSection />}
    </div>
  );
}
